import React, { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../components/Sidebar";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase/firebase";
import { 
  collection, 
  onSnapshot, 
  doc, 
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  limit,
  setDoc,
  addDoc,
  runTransaction,
  getDocs,
  where // <-- FIXED: Added 'where' import
} from "firebase/firestore";
import {
  Search, Trash2, AlertCircle, CheckCircle2, Calendar, Printer, FileText, X, 
  ClipboardList, Receipt, Download, BarChart2, Building2, PieChart, Edit3, 
  Plus, ShoppingBag, CreditCard, ShoppingCart, Percent, User, UserPlus, 
  Stethoscope, Eye, Globe, ArrowRight, MessageSquare, RefreshCw
} from "lucide-react";

const INDIAN_STATES = [
  "Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", 
  "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", 
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Lakshadweep", 
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", 
  "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", 
  "Uttar Pradesh", "Uttarakhand", "West Bengal"
];

export default function AdvancedBillingMatrix() {
  // Navigation Workspaces: storeReports, salesHistory, orderWorkspace
  const [activeTab, setActiveTab] = useState("storeReports"); 
  const [activeBranchId, setActiveBranchId] = useState("all_combined"); 
  const [storesList, setStoresList] = useState([]);
  
  const [storeName, setStoreName] = useState("Global Network");
  const [activeStoreAdress, setActiveStoreAdress] = useState("All Operational Branches Combined Matrix Ledger View");
  const [activeStoreNumber, setActiveStoreNumber] = useState("Multi-Channel Sync Operational");
  
  // Data State Matrices
  const [salesHistoryData, setSalesHistoryData] = useState([]);
  const [products, setProducts] = useState([]);
  const [storeEmployees, setStoreEmployees] = useState([]);
  const [billingCart, setBillingCart] = useState([]);
  const [skuSearchQuery, setSkuSearchQuery] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [systemError, setSystemError] = useState(null);
  const [lastInvoiceNo, setLastInvoiceNo] = useState("");

  // Product Category Quick-Add Models
  const [showProductTypePopup, setShowProductTypePopup] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState("");
  const [productTypeSearchQuery, setProductTypeSearchQuery] = useState("");
  const [quickAddForm, setQuickAddForm] = useState(null);

  // Global Context Filter Matrices
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  // Workspace Order Management Form States
  const [editOrderId, setEditOrderId] = useState(null); 
  const [editOrderStoreId, setEditOrderStoreId] = useState("");
  const [salesDate, setSalesDate] = useState(""); 
  const [deliveryDate, setDeliveryDate] = useState("");
  const [orderReference, setOrderReference] = useState("");
  
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerPhone2, setCustomerPhone2] = useState("");
  const [customerDob, setCustomerDob] = useState("");
  const [customerAnniversary, setCustomerAnniversary] = useState("");
  const [customerCompany, setCustomerCompany] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerLocality, setCustomerLocality] = useState("");
  const [customerState, setCustomerState] = useState("");
  const [customerPincode, setCustomerPincode] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");

  const [salesperson, setSalesperson] = useState("");
  const [overallDiscountType, setOverallDiscountType] = useState("amount"); 
  const [overallDiscountValue, setOverallDiscountValue] = useState("");
  const [advancePaid, setAdvancePaid] = useState("");
  const [taxPercentage, setTaxPercentage] = useState("12");
  const [taxRule, setTaxRule] = useState("include");
  const [paymentMode, setPaymentMode] = useState("CASH");
  const [posPaymentDetails, setPosPaymentDetails] = useState("");
  const [roundOff, setRoundOff] = useState("");

  // Prescription Parameters Matrix
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [prescriptionTab, setPrescriptionTab] = useState("eyewear");
  const [patientName, setPatientName] = useState("");
  const [patientMobile, setPatientMobile] = useState("");
  const [patientEmail, setPatientEmail] = useState("");
  const [patientDob, setPatientDob] = useState("");
  const [patientAge, setPatientAge] = useState("");
  const [patientGender, setPatientGender] = useState("Male");

  const [doctorName, setDoctorName] = useState("");
  const [doctorMobile, setDoctorMobile] = useState("");
  const [doctorAddress, setDoctorAddress] = useState("");

  const [sphRight, setSphRight] = useState(""); const [cylRight, setCylRight] = useState(""); const [axisRight, setAxisRight] = useState("");
  const [sphLeft, setSphLeft] = useState(""); const [cylLeft, setCylLeft] = useState(""); const [axisLeft, setAxisLeft] = useState("");
  const [nvSphRight, setNvSphRight] = useState(""); const [nvCylRight, setNvCylRight] = useState(""); const [nvAxisRight, setNvAxisRight] = useState("");
  const [nvSphLeft, setNvSphLeft] = useState(""); const [nvCylLeft, setNvCylLeft] = useState(""); const [nvAxisLeft, setNvAxisLeft] = useState("");
  const [pdRight, setPdRight] = useState(""); const [vaRight, setVaRight] = useState(""); const [addRight, setAddRight] = useState("");
  const [pdLeft, setPdLeft] = useState(""); const [vaLeft, setVaLeft] = useState(""); const [addLeft, setAddLeft] = useState("");

  const [clSphRight, setClSphRight] = useState(""); const [clCylRight, setClCylRight] = useState(""); const [clAxisRight, setClAxisRight] = useState("");
  const [clSphLeft, setClSphLeft] = useState(""); const [clCylLeft, setClCylLeft] = useState(""); const [clAxisLeft, setClAxisLeft] = useState("");
  const [clNvSphRight, setClNvSphRight] = useState(""); const [clNvCylRight, setClNvCylRight] = useState(""); const [clNvAxisRight, setClNvAxisRight] = useState("");
  const [clNvSphLeft, setClNvSphLeft] = useState(""); const [clNvCylLeft, setClNvCylLeft] = useState(""); const [clNvAxisLeft, setClNvAxisLeft] = useState("");
  const [clAddRight, setClAddRight] = useState(""); const [clAddLeft, setClAddLeft] = useState("");

  const [trnSphRight, setTrnSphRight] = useState(""); const [trnCylRight, setTrnCylRight] = useState(""); const [trnAxisRight, setTrnAxisRight] = useState("");
  const [trnSphLeft, setTrnSphLeft] = useState(""); const [trnCylLeft, setTrnCylLeft] = useState(""); const [trnAxisLeft, setTrnAxisLeft] = useState("");
  const [trnNvSphRight, setTrnNvSphRight] = useState(""); const [trnNvCylRight, setTrnNvCylRight] = useState(""); const [trnNvAxisRight, setTrnNvAxisRight] = useState("");
  const [trnNvSphLeft, setTrnNvSphLeft] = useState(""); const [trnNvCylLeft, setTrnNvCylLeft] = useState(""); const [trnNvAxisLeft, setTrnNvAxisLeft] = useState("");
  const [trnAddRight, setTrnAddRight] = useState(""); const [trnAddLeft, setTrnAddLeft] = useState("");

  const [lensTypes, setLensTypes] = useState([]);
  const [eyeTestRecord, setEyeTestRecord] = useState("Yes");
  const [prescriptionNotes, setPrescriptionNotes] = useState("");

  // Balance Realization Modal Parameters
  const [completingOrder, setCompletingOrder] = useState(null);
  const [completionPaymentMode, setCompletionPaymentMode] = useState("CASH");
  const [completionPaymentDetails, setCompletionPaymentDetails] = useState("");
  const [completionRoundOff, setCompletionRoundOff] = useState("");

  // Custom Line-Item Entry Form Matrix
  const [customItem, setCustomItem] = useState({ productCode: "", productName: "", customPrice: "" });

  const resolvedBranchName = useMemo(() => {
    if (activeBranchId === "all_combined") return "All Branches Combined";
    const matched = storesList.find(s => s.id === activeBranchId);
    return matched ? (matched.storeName || matched.id) : "Selected Store Desk";
  }, [activeBranchId, storesList]);

  // Dynamic Super Admin Configuration - Store Synchronizer
  useEffect(() => {
    const auth = getAuth();
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        onSnapshot(collection(db, "stores"), (snapshot) => {
          if (!snapshot.empty) {
            const pulledStores = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setStoresList(pulledStores);
          }
        });
      }
    });
    return () => unsubscribeAuth();
  }, []);

  // Sync Branch Specifications Metadata
  useEffect(() => {
    if (activeBranchId === "all_combined") {
      setStoreName("Global Network");
      setActiveStoreAdress("All Registered Branches Combined Matrix Ledger View");
      setActiveStoreNumber("Multi-Channel Sync Operational");
    } else if (activeBranchId) {
      const matched = storesList.find(s => s.id === activeBranchId);
      if (matched) {
        setStoreName(matched.storeName || matched.storeId || matched.id);
        setActiveStoreAdress(matched.address || "CHANDRAKANTI COMPLEX OPP KHAJPURA, PATNA - 800014, Bihar, India");
        setActiveStoreNumber(matched.phone || "06123590450");
      }
    }
  }, [activeBranchId, storesList]);

  // High-Performance Dynamic Cross-Store Reactive Data Aggregator Engine
  useEffect(() => {
    if (storesList.length === 0) return;

    let unsubs = [];
    const salesAccumulatorMap = {};

    const handleUpdate = () => {
      let unifiedArray = [];
      Object.keys(salesAccumulatorMap).forEach(branchKey => {
        unifiedArray = [...unifiedArray, ...salesAccumulatorMap[branchKey]];
      });
      unifiedArray.sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0));
      setSalesHistoryData(unifiedArray);
    };

    if (activeBranchId === "all_combined") {
      storesList.forEach(store => {
        const q = query(
          collection(db, "stores", store.id, "sales"),
          orderBy("timestamp", "desc"),
          limit(300)
        );
        const unsub = onSnapshot(q, (snap) => {
          salesAccumulatorMap[store.id] = snap.docs.map(d => ({
            id: d.id,
            storeId: store.id,
            branchContextName: store.storeName || store.id,
            ...d.data()
          }));
          handleUpdate();
        }, (err) => console.error("Cross-store stream exception:", err));
        unsubs.push(unsub);
      });
    } else {
      const q = query(
        collection(db, "stores", activeBranchId, "sales"),
        orderBy("timestamp", "desc"),
        limit(1500)
      );
      const unsub = onSnapshot(q, (snap) => {
        salesAccumulatorMap[activeBranchId] = snap.docs.map(d => ({
          id: d.id,
          storeId: activeBranchId,
          branchContextName: resolvedBranchName,
          ...d.data()
        }));
        handleUpdate();
      });
      unsubs.push(unsub);
    }

    return () => unsubs.forEach(fn => fn());
  }, [activeBranchId, storesList, resolvedBranchName]);

  // Synchronize Inventory & Sub-Catalogs dynamically for targeted workspace context operations
  useEffect(() => {
    if (!activeBranchId || activeBranchId === "all_combined") {
      setProducts([]);
      setStoreEmployees([]);
      return;
    }
    const unsubInv = onSnapshot(collection(db, "stores", activeBranchId, "inventory"), (snap) => {
      setProducts(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    const unsubEmp = onSnapshot(collection(db, "stores", activeBranchId, "employees"), (snap) => {
      setStoreEmployees(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => { unsubInv(); unsubEmp(); };
  }, [activeBranchId]);

  // Patient Demographics Matrix Age Estimator Hook
  useEffect(() => {
    if (patientDob) {
      const dob = new Date(patientDob);
      const diff = Date.now() - dob.getTime();
      const ageDate = new Date(diff);
      setPatientAge(Math.abs(ageDate.getUTCFullYear() - 1970).toString());
    }
  }, [patientDob]);

  const handlePhoneBlurCustomer = async () => {
    if (!customerPhone || customerPhone.length < 10 || !activeBranchId || activeBranchId === "all_combined") return;
    try {
      const custQ = query(collection(db, "stores", activeBranchId, "customers"), where("phone", "==", customerPhone));
      const custSnap = await getDocs(custQ);
      if (!custSnap.empty) {
        const cData = custSnap.docs[0].data();
        if (cData.name) setCustomerName(cData.name);
        if (cData.phone2) setCustomerPhone2(cData.phone2);
        if (cData.dob) setCustomerDob(cData.dob);
        if (cData.anniversary) setCustomerAnniversary(cData.anniversary);
        if (cData.company) setCustomerCompany(cData.company);
        if (cData.address) setCustomerAddress(cData.address);
        if (cData.locality) setCustomerLocality(cData.locality);
        if (cData.state) setCustomerState(cData.state);
        if (cData.pincode) setCustomerPincode(cData.pincode);
        if (cData.notes) setCustomerNotes(cData.notes);
      }
    } catch (err) {
      console.error("Profile auto-lookup aborted:", err);
    }
  };

  const clearPrescriptionForm = () => {
    setPatientName(""); setPatientMobile(""); setPatientEmail(""); setPatientDob(""); setPatientAge(""); setPatientGender("Male");
    setDoctorName(""); setDoctorMobile(""); setDoctorAddress("");
    setSphLeft(""); setSphRight(""); setCylLeft(""); setCylRight(""); setAxisLeft(""); setAxisRight(""); setPdRight(""); setPdLeft(""); setVaRight(""); setVaLeft(""); setAddRight(""); setAddLeft("");
    setNvSphLeft(""); setNvSphRight(""); setNvCylLeft(""); setNvCylRight(""); setNvAxisLeft(""); setNvAxisRight("");
    setClSphRight(""); setClSphLeft(""); setClCylRight(""); setClCylLeft(""); setClAxisRight(""); setClAxisLeft(""); setClAddRight(""); setClAddLeft("");
    setClNvSphRight(""); setClNvSphLeft(""); setClNvCylRight(""); setClNvCylLeft(""); setClNvAxisRight(""); setClNvAxisLeft("");
    // FIXED: Removed the stray text-slate-800 snippet from here
    setTrnSphRight(""); setTrnSphLeft(""); setTrnCylRight(""); setTrnCylLeft(""); setTrnAxisRight(""); setTrnAxisLeft(""); setTrnAddRight(""); setTrnAddLeft("");
    setTrnNvSphRight(""); setTrnNvCylRight(""); setTrnNvCylLeft(""); setTrnNvAxisRight(""); setTrnNvAxisLeft("");
    setLensTypes([]); setEyeTestRecord("Yes"); setPrescriptionNotes("");
  };

  const resetForm = () => {
    setBillingCart([]);
    setCustomerName(""); setCustomerPhone(""); setCustomerPhone2(""); setCustomerAddress(""); setSalesperson(""); setCustomerCompany(""); setCustomerLocality(""); setCustomerState(""); setCustomerPincode(""); setCustomerNotes(""); setCustomerDob(""); setCustomerAnniversary("");
    clearPrescriptionForm();
    setAdvancePaid(""); setDeliveryDate(""); setOrderReference(""); setRoundOff(""); setOverallDiscountType("amount"); setOverallDiscountValue(""); setPosPaymentDetails(""); setPaymentMode("CASH");
    setEditOrderId(null); setEditOrderStoreId(""); setCompletingOrder(null);
  };

  const isLensProduct = (product) => {
    const pName = product.productName?.toLowerCase() || "";
    const pCode = product.productCode?.toLowerCase() || "";
    return pName.includes("lens") || pCode.includes("lens") || product.productType === "Glass" || product.productType === "Lens" || product.productType === "Contact Lens";
  };

  // Live Auto-suggest Filter Compute Map
  const scannedMatches = useMemo(() => {
    if (!skuSearchQuery.trim()) return [];
    return products.filter(p => p.productName?.toLowerCase().includes(skuSearchQuery.toLowerCase()) || p.productCode?.toLowerCase().includes(skuSearchQuery.toLowerCase()));
  }, [skuSearchQuery, products]);

  // Consolidated Processing Pipeline: Live Reactive Ledger Mapping Filter Hook
  const completedSalesLedger = useMemo(() => {
    return salesHistoryData.filter(s => {
      if (!s.timestamp) return true;
      const orderDate = s.timestamp.split("T")[0];
      if (startDate && orderDate < startDate) return false;
      if (endDate && orderDate > endDate) return false;
      
      const bal = s.financials?.balanceDue || 0;
      if (filterStatus === "Pending" && bal <= 0) return false;
      if (filterStatus === "Completed" && bal > 0) return false;

      if (filterSearch) {
        const term = filterSearch.toLowerCase();
        const matchInv = s.invoiceNo?.toLowerCase().includes(term);
        const matchName = s.customer?.name?.toLowerCase().includes(term);
        const matchPhone = s.customer?.phone?.includes(term);
        const matchRep = s.salesperson?.toLowerCase().includes(term);
        if (!matchInv && !matchName && !matchPhone && !matchRep) return false;
      }
      return true;
    });
  }, [salesHistoryData, startDate, endDate, filterStatus, filterSearch]);

  // Integrated Workspace Mod Injector Machine
  const loadOrderForEditing = (order) => {
    if (!order.storeId || order.storeId === "Unknown") {
      alert("Aborted. Source branch identifier context missing from record structure.");
      return;
    }
    setEditOrderId(order.id);
    setEditOrderStoreId(order.storeId);
    setActiveBranchId(order.storeId);

    const mappedCart = (order.items || []).map((i, idx) => ({
      ...i,
      id: i.productCode || `imported_${idx}`,
      productCode: i.productCode || "",
      productName: i.productName || "",
      retailPrice: Number(i.retailPrice) || Number(i.mrp) || 0,
      mrp: Number(i.mrp) || Number(i.retailPrice) || 0,
      cartQuantity: Number(i.quantity) || 1,
      customDiscount: Number(i.discount) || 0,
      isCustomItem: true
    }));
    setBillingCart(mappedCart);

    setCustomerName(order.customer?.name || "");
    setCustomerPhone(order.customer?.phone || "");
    setCustomerPhone2(order.customer?.phone2 || "");
    setCustomerDob(order.customer?.dob || "");
    setCustomerAnniversary(order.customer?.anniversary || "");
    setCustomerCompany(order.customer?.company || "");
    setCustomerAddress(order.customer?.address || "");
    setCustomerLocality(order.customer?.locality || "");
    setCustomerState(order.customer?.state || "");
    setCustomerPincode(order.customer?.pincode || "");
    setCustomerNotes(order.customer?.notes || "");

    setSalesperson(order.salesperson || "");
    setSalesDate(order.checkout?.placementDate || order.timestamp?.split("T")[0] || "");
    setDeliveryDate(order.checkout?.deliveryDate || "");
    setOrderReference(order.invoiceNo || "");
    
    setTaxRule(order.checkout?.taxRule || "include");
    setTaxPercentage(order.checkout?.taxPercentage || "12");
    setOverallDiscountType(order.checkout?.overallDiscountType || "amount");
    setOverallDiscountValue(order.checkout?.overallDiscountValue || "");
    setRoundOff(order.checkout?.roundOff || "");
    setAdvancePaid(order.checkout?.advancePaid || "");

    const firstPayment = order.checkout?.paymentHistory?.[0] || {};
    setPaymentMode(firstPayment.mode || order.checkout?.paymentMode || "CASH");
    setPosPaymentDetails(firstPayment.details || "");

    if (order.prescription) {
      const rxData = order.prescription;
      setPatientName(rxData.patient?.name || "");
      setPatientMobile(rxData.patient?.mobile || "");
      setPatientEmail(rxData.patient?.email || "");
      setPatientDob(rxData.patient?.dob || "");
      setPatientAge(rxData.patient?.age || "");
      setPatientGender(rxData.patient?.gender || "Male");

      setDoctorName(rxData.doctor?.name || "");
      setDoctorMobile(rxData.doctor?.mobile || "");
      setDoctorAddress(rxData.doctor?.address || "");

      setSphRight(rxData.sphRight || ""); setCylRight(rxData.cylRight || ""); setAxisRight(rxData.axisRight || "");
      setSphLeft(rxData.sphLeft || ""); setCylLeft(rxData.cylLeft || ""); setAxisLeft(rxData.axisLeft || "");
      setNvSphRight(rxData.nvSphRight || ""); setNvCylRight(rxData.nvCylRight || ""); setNvAxisRight(rxData.nvAxisRight || "");
      setNvSphLeft(rxData.nvSphLeft || ""); setNvCylLeft(rxData.nvCylLeft || ""); setNvAxisLeft(rxData.nvAxisLeft || "");
      setPdRight(rxData.pdRight || ""); setVaRight(rxData.vaRight || ""); setAddRight(rxData.addRight || "");
      setPdLeft(rxData.pdLeft || ""); setVaLeft(rxData.vaLeft || ""); setAddLeft(rxData.addLeft || "");

      setClSphRight(rxData.clSphRight || ""); setClCylRight(rxData.clCylRight || ""); setClAxisRight(rxData.clAxisRight || "");
      setClSphLeft(rxData.clSphLeft || ""); setClCylLeft(rxData.clCylLeft || ""); setClAxisLeft(rxData.clAxisLeft || "");
      setClNvSphRight(rxData.clNvSphRight || ""); setClNvCylRight(rxData.clNvCylRight || ""); setClNvAxisRight(rxData.clNvAxisRight || "");
      setClNvSphLeft(rxData.clNvSphLeft || ""); setClNvCylLeft(rxData.clNvCylLeft || ""); setClNvAxisLeft(rxData.clNvAxisLeft || "");
      setClAddRight(rxData.clAddRight || ""); setClAddLeft(rxData.clAddLeft || "");

      setTrnSphRight(rxData.trnSphRight || ""); setTrnCylRight(rxData.trnCylRight || ""); setTrnAxisRight(rxData.trnAxisRight || "");
      setTrnSphLeft(rxData.trnSphLeft || ""); setTrnCylLeft(rxData.trnCylLeft || ""); setTrnAxisLeft(rxData.trnAxisLeft || "");
      setTrnNvSphRight(rxData.trnNvSphRight || ""); setTrnNvCylRight(rxData.trnNvCylRight || ""); setTrnNvAxisRight(rxData.trnNvAxisRight || "");
      setTrnNvSphLeft(rxData.trnNvSphLeft || ""); setTrnNvCylLeft(rxData.trnNvCylLeft || ""); setTrnNvAxisLeft(rxData.trnNvAxisLeft || "");
      setTrnAddRight(rxData.trnAddRight || ""); setTrnAddLeft(rxData.trnAddLeft || "");

      setLensTypes(rxData.lensTypes || []);
      setEyeTestRecord(rxData.eyeTestRecord || "Yes");
      setPrescriptionNotes(rxData.prescriptionNotes || "");
    } else {
      clearPrescriptionForm();
    }

    setActiveTab("orderWorkspace");
  };

  const addToCartAction = (product, customConfig = null) => {
    const lensCheck = isLensProduct(product);
    if (!lensCheck && Number(product.quantity) <= 0 && !editOrderId) {
      return alert(`Low stock condition! Items available: ${product.quantity}`);
    }
    
    let activePrice = customConfig ? Number(customConfig.retailPrice) : (Number(product.retailPrice) || Number(product.mrp) || 0);
    let activeDiscount = customConfig ? Number(customConfig.discountAmount) : 0;
    
    const cartIndex = billingCart.findIndex(item => item.id === product.id);
    if (cartIndex !== -1) {
      if (!lensCheck && billingCart[cartIndex].cartQuantity >= Number(product.quantity) && !editOrderId) {
        return alert(`Overallocation limit reached. Operational store inventory limits: ${product.quantity}`);
      }
      const updated = [...billingCart]; updated[cartIndex].cartQuantity += 1;
      setBillingCart(updated);
    } else {
      setBillingCart([...billingCart, { 
        ...product, 
        retailPrice: activePrice,
        cartQuantity: 1, 
        customDiscount: activeDiscount, 
        isCustomItem: false 
      }]);
    }
    setSkuSearchQuery("");
    if (lensCheck) setShowPrescriptionModal(true);
  };

  const handleInjectCustomProduct = () => {
    if (!customItem.productCode || !customItem.productName || !customItem.customPrice) return alert("Fill out custom entry attributes entirely.");
    setBillingCart([...billingCart, {
      id: `CUSTOM_${Date.now()}`, productCode: customItem.productCode.toUpperCase(), productName: customItem.productName,
      mrp: Number(customItem.customPrice), retailPrice: Number(customItem.customPrice), cartQuantity: 1, customDiscount: 0, isCustomItem: true
    }]);
    if (isLensProduct(customItem)) setShowPrescriptionModal(true);
    setCustomItem({ productCode: "", productName: "", customPrice: "" });
  };

  const updateCartQty = (id, newQty) => {
    if (newQty <= 0) { setBillingCart(billingCart.filter(i => i.id !== id)); return; }
    const target = billingCart.find(i => i.id === id);
    const lensCheck = isLensProduct(target);
    
    if (!target.isCustomItem && !lensCheck && newQty > Number(target.quantity) && !editOrderId) {
      return alert(`Overallocation limit reached. Operational store inventory limits: ${target.quantity}`);
    }
    setBillingCart(billingCart.map(i => i.id === id ? { ...i, cartQuantity: Number(newQty) } : i));
  };

  const updateCartDiscount = (id, discount) => {
    setBillingCart(billingCart.map(i => i.id === id ? { ...i, customDiscount: Number(discount) } : i));
  };

  const toggleLensType = (type) => {
    if (lensTypes.includes(type)) setLensTypes(lensTypes.filter(t => t !== type));
    else setLensTypes([...lensTypes, type]);
  };

  // Operational Checkout Terminal Value Calculations Engine
  const financials = useMemo(() => {
    let subtotal = 0; let totalItemDiscount = 0; let mrpRetailDiff = 0;
    billingCart.forEach(item => { 
      const qty = Number(item.cartQuantity);
      const retail = Number(item.retailPrice) || 0;
      const mrp = Number(item.mrp) || retail; 
      subtotal += retail * qty; 
      totalItemDiscount += (Number(item.customDiscount) || 0); 
      mrpRetailDiff += (mrp - retail) * qty;
    });
    
    let baseAfterItemDisc = subtotal - totalItemDiscount;
    let calculatedOverallDisc = 0;
    const oDiscVal = Number(overallDiscountValue) || 0;
    if (overallDiscountType === "percent") {
      calculatedOverallDisc = baseAfterItemDisc * (oDiscVal / 100);
    } else {
      calculatedOverallDisc = oDiscVal;
    }

    if (calculatedOverallDisc > baseAfterItemDisc) calculatedOverallDisc = baseAfterItemDisc;
    const baselineBase = baseAfterItemDisc - calculatedOverallDisc;
    const totalDiscount = totalItemDiscount + calculatedOverallDisc;
    const computedTax = taxRule === "exclude" ? baselineBase * (Number(taxPercentage) / 100) : (taxRule === "include" ? baselineBase - (baselineBase / (1 + (Number(taxPercentage) / 100))) : 0);
    
    let netPayable = taxRule === "exclude" ? baselineBase + computedTax : baselineBase;
    const unroundedNetPayable = netPayable;
    netPayable += Number(roundOff) || 0; 
    const totalYouSave = mrpRetailDiff + totalDiscount;

    return { 
      subtotal, totalDiscount, mrpRetailDiff, totalYouSave, computedTax, netPayable, unroundedNetPayable, 
      balanceDue: netPayable - (Number(advancePaid) || 0), overallDiscountApplied: calculatedOverallDisc
    };
  }, [billingCart, taxRule, taxPercentage, advancePaid, roundOff, overallDiscountType, overallDiscountValue]);

  // Cross-Store Multi-Channel Transaction Committer Pipeline
  const commitInvoiceTransaction = async (isDirectInvoice = false) => {
    if (!customerName || !customerPhone || !salesperson) return setSystemError("Customer identity specs and attending agent assignments required.");
    if (billingCart.length === 0) return setSystemError("Operation halted. Billing collection contains no items.");
    if (isDirectInvoice && financials.balanceDue > 0) return setSystemError("Direct Settlement invoices restrict deferred balances.");
    
    setIsProcessing(true); setSystemError(null);
    let invoiceNumber = orderReference;
    
    if (!editOrderId && !invoiceNumber) {
      const yearPrefix = `${new Date().getFullYear().toString().slice(-2)}-`;
      let nextInv = 1001;
      const existingOpt = salesHistoryData
        .filter(s => s.invoiceNo && s.invoiceNo.startsWith(yearPrefix))
        .map(s => parseInt(s.invoiceNo.replace(yearPrefix, ""), 10))
        .filter(n => !isNaN(n));
      if (existingOpt.length > 0) nextInv = Math.max(...existingOpt) + 1;
      invoiceNumber = `${yearPrefix}${nextInv}`;
    }

    const finalDeliveryDate = deliveryDate || new Date().toISOString().split("T")[0];
    const isPending = !isDirectInvoice && (financials.balanceDue > 0);
    const initialPaid = isDirectInvoice ? financials.netPayable : Number(advancePaid);
    const targetStoreId = editOrderId ? editOrderStoreId : activeBranchId;

    try {
      const customerPayload = JSON.parse(JSON.stringify({
        name: customerName, phone: customerPhone, phone2: customerPhone2, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, address: customerAddress, locality: customerLocality, state: customerState, pincode: customerPincode, notes: customerNotes, lastUpdated: new Date().toISOString()
      }));
      await setDoc(doc(db, "stores", targetStoreId, "customers", customerPhone), customerPayload, { merge: true });

      let rxPayload = null;
      if (patientName || sphLeft || sphRight) {
        rxPayload = {
          patient: { name: patientName, mobile: patientMobile, email: patientEmail, dob: patientDob, age: patientAge, gender: patientGender },
          doctor: { name: doctorName, mobile: doctorMobile, address: doctorAddress },
          sphRight, cylRight, axisRight, pdRight, vaRight, addRight, sphLeft, cylLeft, axisLeft, pdLeft, vaLeft, addLeft,
          nvSphRight, nvCylRight, nvAxisRight, nvSphLeft, nvCylLeft, nvAxisLeft,
          clSphRight, clCylRight, clAxisRight, clAddRight, clSphLeft, clCylLeft, clAxisLeft, clAddLeft,
          clNvSphRight, clNvCylRight, clNvAxisRight, clNvSphLeft, clNvCylLeft, clNvAxisLeft,
          trnSphRight, trnCylRight, trnAxisRight, trnAddRight, trnSphLeft, trnCylLeft, trnAxisLeft, trnAddLeft,
          trnNvSphRight, trnNvCylRight, trnNvAxisRight, trnNvSphLeft, trnNvCylLeft, trnNvAxisLeft,
          lensTypes, eyeTestRecord, prescriptionNotes, timestamp: new Date().toISOString()
        };
      }

      const itemsList = billingCart.map(i => ({ 
        productCode: i.productCode || "", productName: i.productName || "Standard Unit Item", quantity: Number(i.cartQuantity) || 1, mrp: Number(i.mrp || i.retailPrice) || 0, retailPrice: Number(i.retailPrice) || 0, discount: Number(i.customDiscount) || 0 
      }));

      if (editOrderId) {
        const oldOrder = salesHistoryData.find(o => o.id === editOrderId);
        let updatedHistory = oldOrder?.checkout?.paymentHistory || [];
        if (updatedHistory.length > 0) {
          updatedHistory[0] = { ...updatedHistory[0], amount: initialPaid, mode: paymentMode, details: posPaymentDetails };
        } else {
          updatedHistory = [{ amount: initialPaid, mode: paymentMode, details: posPaymentDetails, date: new Date().toISOString() }];
        }
        const reCalculatedTotalPaid = updatedHistory.reduce((acc, curr) => acc + (Number(curr.amount) || 0), 0);

        const updatePayload = JSON.parse(JSON.stringify({
          salesperson, orderStatus: isPending ? "Pending" : "Completed",
          customer: { name: customerName, phone: customerPhone, phone2: customerPhone2, address: customerAddress, state: customerState, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, locality: customerLocality, pincode: customerPincode, notes: customerNotes },
          prescription: rxPayload,
          checkout: { taxRule, taxPercentage, paymentMode, advancePaid: Number(advancePaid) || 0, roundOff: Number(roundOff) || 0, overallDiscountType, overallDiscountValue: Number(overallDiscountValue) || 0, deliveryDate: finalDeliveryDate, placementDate: salesDate, totalAmountPaid: reCalculatedTotalPaid, paymentHistory: updatedHistory },
          items: itemsList,
          financials: { subtotal: financials.subtotal, totalDiscount: financials.totalDiscount, totalYouSave: financials.totalYouSave, computedTax: financials.computedTax, netPayable: financials.netPayable, balanceDue: financials.netPayable - reCalculatedTotalPaid }
        }));
        await updateDoc(doc(db, "stores", targetStoreId, "sales", editOrderId), updatePayload);
      } else {
        await runTransaction(db, async (txn) => {
          const newSaleRef = doc(collection(db, "stores", targetStoreId, "sales"));
          const salesPayload = JSON.parse(JSON.stringify({
            invoiceNo: invoiceNumber, branch: storeName, timestamp: new Date().toISOString(), orderStatus: isPending ? "Pending" : "Completed", salesperson,
            customer: { name: customerName, phone: customerPhone, phone2: customerPhone2, address: customerAddress, state: customerState, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, locality: customerLocality, pincode: customerPincode, notes: customerNotes },
            prescription: rxPayload,
            checkout: { taxRule, taxPercentage, paymentMode, advancePaid: Number(advancePaid) || 0, roundOff: Number(roundOff) || 0, overallDiscountType, overallDiscountValue: Number(overallDiscountValue) || 0, deliveryDate: finalDeliveryDate, placementDate: new Date().toISOString().split("T")[0], totalAmountPaid: initialPaid, paymentHistory: [{ amount: initialPaid, mode: paymentMode, details: posPaymentDetails, date: new Date().toISOString() }] },
            items: itemsList,
            financials: { subtotal: financials.subtotal, totalDiscount: financials.totalDiscount, totalYouSave: financials.totalYouSave, computedTax: financials.computedTax, netPayable: financials.netPayable, balanceDue: financials.balanceDue }
          }));
          txn.set(newSaleRef, salesPayload);
        });
        setLastInvoiceNo(invoiceNumber);
      }
      resetForm(); setActiveTab("salesHistory");
    } catch (e) { setSystemError(e.message); } 
    finally { setIsProcessing(false); }
  };

  // FIXED: Trigger balance completion modal logic restored.
  const triggerCompletionFlow = (order) => {
    setCompletionPaymentMode("CASH");
    setCompletionPaymentDetails("");
    setCompletionRoundOff("");
    setCompletingOrder(order);
  };

  const handleFinalizePendingOrder = async () => {
    if (!completingOrder) return;
    try {
      const manualRoundOff = Number(completionRoundOff) || 0;
      const targetPaymentAmount = completingOrder.financials.balanceDue - manualRoundOff;
      const history = completingOrder.checkout?.paymentHistory || [];
      history.push({ amount: targetPaymentAmount, mode: completionPaymentMode, details: completionPaymentDetails, date: new Date().toISOString() });
      const newTotalPaid = (completingOrder.checkout?.totalAmountPaid || 0) + targetPaymentAmount;
      const accumulatedRoundOff = (completingOrder.checkout?.roundOff || 0) + manualRoundOff;
      const targetStoreId = completingOrder.storeId || activeBranchId;

      await updateDoc(doc(db, "stores", targetStoreId, "sales", completingOrder.id), { 
        orderStatus: "Completed", "financials.balanceDue": 0, "checkout.totalAmountPaid": newTotalPaid, "checkout.roundOff": accumulatedRoundOff, "checkout.paymentHistory": history
      });
      alert("Deferred payment balance verified and registered successfully!");
      setCompletingOrder(null);
    } catch (e) { console.error(e); }
  };

  const handleDeleteOrder = async (orderId, orderStoreId) => {
    if (!window.confirm("Delete this operational transaction log permanently from the central database? This action cannot be reverted.")) return;
    try { 
      const targetStoreId = orderStoreId || activeBranchId;
      await deleteDoc(doc(db, "stores", targetStoreId, "sales", orderId)); 
      alert("Log removed successfully."); 
    } catch (e) { setSystemError("Database deletion routing transaction exception."); }
  };

  // Comprehensive Reporting Matrix Computer
  const reportSummaryData = useMemo(() => {
    let cash = 0, upi = 0, card = 0;
    let totalNet = 0, totalAdvance = 0, totalRoundoff = 0;
    completedSalesLedger.forEach(order => {
      totalNet += (order.financials?.netPayable || 0);
      totalAdvance += (order.checkout?.advancePaid || 0);
      totalRoundoff += (order.checkout?.roundOff || 0);
      const history = order.checkout?.paymentHistory || [];
      if (history.length === 0 && order.checkout?.advancePaid > 0) cash += order.checkout.advancePaid;
      history.forEach(p => {
        const mode = (p.mode || "").toUpperCase();
        if (mode.includes("UPI") || mode.includes("GPAY")) upi += p.amount;
        else if (mode.includes("CARD")) card += p.amount;
        else cash += p.amount;
      });
    });

    const totalCollected = cash + upi + card;
    let gradient = "conic-gradient(#f1f5f9 0% 100%)";
    if (totalCollected > 0) {
      const cashPct = Math.round((cash / totalCollected) * 100);
      const upiPct = Math.round((upi / totalCollected) * 100);
      gradient = `conic-gradient(#3b82f6 0% ${cashPct}%, #10b981 ${cashPct}% ${cashPct + upiPct}%, #a855f7 ${cashPct + upiPct}% 100%)`;
    }
    return { cash, upi, card, totalCollected, totalNet, totalAdvance, totalRoundoff, gradient };
  }, [completedSalesLedger]);

  // Presentation-Grade Structured Data Exporters
  const handleExportReportExcel = () => {
    if (completedSalesLedger.length === 0) return alert("Operation canceled. Active dataset contains no files.");
    let csvContent = "data:text/csv;charset=utf-8,Branch Context,Date,Invoice Ref,Customer Profiling,Operator Rep,Line-Items Context,Payment Channels,Advance Locked,Adjustments,Total Yield\n";
    completedSalesLedger.forEach(order => {
      const date = new Date(order.timestamp).toLocaleDateString("en-GB");
      const itemsStr = (order.items || []).map(i => `${i.productName} (x${i.quantity})`).join(" | ");
      const modesStr = (order.checkout?.paymentHistory || []).map(p => p.mode).join(" & ") || "CASH";
      const row = [
        `"${order.branchContextName || storeName}"`, date, order.invoiceNo, `"${order.customer?.name || "Walk-In Profile"}"`, `"${order.salesperson || "System Integration"}"`, `"${itemsStr}"`, modesStr, order.checkout?.advancePaid || 0, order.checkout?.roundOff || 0, order.financials?.netPayable || 0
      ];
      csvContent += row.join(",") + "\n";
    });
    const link = document.createElement("a");
    link.setAttribute("href", encodeURI(csvContent));
    link.setAttribute("download", `Master_Corporate_Report_${resolvedBranchName}.csv`);
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
  };

  const handlePrintReportPDF = () => {
    const printWindow = window.open("", "_blank");
    const tableRows = completedSalesLedger.map(order => {
      const itemsStr = (order.items || []).map(i => `${i.productName} <span style="color:#64748b;">(x${i.quantity})</span>`).join("<br/>");
      const modesStr = (order.checkout?.paymentHistory || []).map(p => p.mode).join("<br/>") || "CASH";
      return `
      <tr>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; color:#64748b; font-size:11px;">${order.branchContextName || "Main Channel"}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; color:#475569;">${new Date(order.timestamp).toLocaleDateString("en-GB")}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; font-weight:600; color:#1e293b; font-mono">${order.invoiceNo}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; color:#334155;">${order.customer?.name || "Walk-In"}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; color:#64748b; font-size:11px;">${order.salesperson || "System"}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; font-size:11px; color:#334155;">${itemsStr}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; font-size:10px; color:#64748b; text-transform:uppercase;">${modesStr}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; text-align:right; font-mono; color:#475569;">₹${Number(order.checkout?.advancePaid || 0).toFixed(2)}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; text-align:right; font-mono; color:#94a3b8;">₹${Number(order.checkout?.roundOff || 0).toFixed(2)}</td>
        <td style="padding:10px 12px; border-bottom:1px solid #e2e8f0; text-align:right; font-weight:700; color:#0f172a; font-mono; font-size:13px;">₹${Number(order.financials?.netPayable || 0).toFixed(2)}</td>
      </tr>`;
    }).join("");

    const html = `
      <html>
        <head>
          <title>Executive Statement - ${resolvedBranchName}</title>
          <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&display=swap" rel="stylesheet">
          <style>
            body { font-family: 'Inter', sans-serif; padding: 30px; margin: 0; background: #fff; color: #0f172a; -webkit-print-color-adjust: exact; }
            .header { border-bottom: 2px solid #0f172a; padding-bottom: 16px; margin-bottom: 25px; display: flex; justify-content: space-between; align-items: flex-end; }
            .header h1 { margin: 0; font-size: 24px; font-weight: 900; text-transform: uppercase; letter-spacing: -0.5px; color:#1e3a8a; }
            .header p { margin: 4px 0 0 0; color: #475569; font-size: 12px; font-weight: 500; }
            .metrics-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 15px; margin-bottom: 25px; }
            .metric-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; box-shadow: inset 0 1px 2px rgba(0,0,0,0.02); }
            .metric-title { font-size: 9px; text-transform: uppercase; color: #64748b; font-weight: 700; letter-spacing: 0.5px; margin-bottom: 4px; }
            .metric-value { font-size: 20px; font-weight: 700; font-family: monospace; }
            .text-green { color: #10b981; } .text-amber { color: #f59e0b; } .text-blue { color: #3b82f6; } .text-slate { color: #1e293b; }
            table { width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 15px; }
            th { background: #f1f5f9; padding: 10px 12px; text-align: left; font-size: 9px; text-transform: uppercase; color: #475569; font-weight: 800; border-bottom: 2px solid #e2e8f0; }
            .footer { margin-top: 35px; text-align: center; font-size: 9px; color: #94a3b8; border-top: 1px solid #e2e8f0; padding-top: 15px; font-weight: 500; }
          </style>
        </head>
        <body>
          <div class="header">
            <div>
              <h1>Network Corporate Statement</h1>
              <p>Workspace Scope: ${resolvedBranchName}</p>
            </div>
            <div style="text-align: right;">
              <p>Period Framework: ${startDate ? new Date(startDate).toLocaleDateString("en-GB") : "Inception"} - ${endDate ? new Date(endDate).toLocaleDateString("en-GB") : "Active Present"}</p>
              <p>System Timestamp: ${new Date().toLocaleString("en-GB")}</p>
            </div>
          </div>
          <div class="metrics-grid">
             <div class="metric-card"><div class="metric-title">Aggregate Gross Value</div><div class="metric-value text-blue">₹${reportSummaryData.totalNet.toFixed(2)}</div></div>
             <div class="metric-card"><div class="metric-title">Secured Commitments</div><div class="metric-value text-amber">₹${reportSummaryData.totalAdvance.toFixed(2)}</div></div>
             <div class="metric-card"><div class="metric-title">Differential Metrics</div><div class="metric-value text-slate">₹${reportSummaryData.totalRoundoff.toFixed(2)}</div></div>
             <div class="metric-card"><div class="metric-title">Net Liquidity Realized</div><div class="metric-value text-green">₹${reportSummaryData.totalCollected.toFixed(2)}</div></div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Branch</th><th>Date</th><th>Invoice Ref</th><th>Customer Profile</th><th>Attending Rep</th><th>Line-Items Profile</th><th>Channel</th><th style="text-align:right;">Commitments</th><th style="text-align:right;">Adjustments</th><th style="text-align:right;">Net Yield</th>
              </tr>
            </thead>
            <tbody>${tableRows}</tbody>
          </table>
          <div class="footer">Confidential System Generated Ledger Document. Distributed Admin Rights Apply. Authorization Protected.</div>
          <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); }</script>
        </body>
      </html>`;
    printWindow.document.write(html); printWindow.document.close();
  };

  const handlePrintLedger = () => {
    const printWindow = window.open("", "_blank");
    const tableHtml = completedSalesLedger.map(order => `
      <tr>
        <td style="padding: 8px; border: 1px solid #ddd; font-family: monospace;">${order.invoiceNo}</td>
        <td style="padding: 8px; border: 1px solid #ddd;">${new Date(order.timestamp).toLocaleDateString("en-GB")}</td>
        <td style="padding: 8px; border: 1px solid #ddd;">${order.customer?.name || "Walk-In"}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">Rs ${(order.financials?.netPayable || 0).toFixed(2)}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: right; color: #10b981;">Rs ${(order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0).toFixed(2)}</td>
        <td style="padding: 8px; border: 1px solid #ddd; text-align: right; color: #ef4444;">Rs ${(order.financials?.balanceDue || 0).toFixed(2)}</td>
      </tr>
    `).join("");

    const html = `
      <html>
        <head><title>Sales Ledger - ${resolvedBranchName}</title></head>
        <body style="font-family: Arial, sans-serif; padding: 20px; color: #334155;">
          <h2 style="text-align: center; color: #1e3a8a; text-transform: uppercase; margin-bottom: 5px;">Sales Ledger Control Registry</h2>
          <h4 style="text-align: center; color: #64748b; margin-top: 0;">Scope Framework: ${storeName} | Range: ${startDate || "All Time"} to ${endDate || "Present"}</h4>
          <table style="width: 100%; border-collapse: collapse; margin-top: 25px; font-size: 13px;">
            <tr style="background: #f8fafc; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid #cbd5e1;">
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">Invoice Ref</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">Timestamp</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">Customer Target</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: right;">Gross Liability</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: right;">Realized Assets</th>
              <th style="padding: 10px; border: 1px solid #ddd; text-align: right;">Outstanding Balances</th>
            </tr>
            ${tableHtml}
          </table>
          <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); }</script>
        </body>
      </html>`;
    printWindow.document.write(html); printWindow.document.close();
  };

  const handlePrintOrderForm = (order) => {
    const printWindow = window.open("", "_blank");
    const dateObj = new Date(order.timestamp);
    const orderDateStr = dateObj.toLocaleDateString("en-GB");
    const deliveryDateRaw = order.checkout?.deliveryDate || dateObj.toISOString().split("T")[0];
    const deliveryDateStr = deliveryDateRaw.split("-").reverse().join("-");
    const rx = order.prescription || {};

    const itemsHtml = (order.items || []).map((item, idx) => {
      const isLens = item.productName?.toLowerCase().includes("lens") || item.productCode?.toLowerCase().includes("lens");
      let rxHtml = "";
      if (isLens && order.prescription) {
        rxHtml = `
          <div class="prescriptionWrapper" style="margin-top:10px;">
              <table style="width:100%; border-collapse:collapse; font-size:12px; border:1px solid #000;">
              <tr style="font-weight:bold; background:#f5f5f5;">
                <td colspan="5">✓ RIGHT EYE (OD)</td><td colspan="5">✓ LEFT EYE (OS)</td>
              </tr>
              <tr style="font-size:11px;">
                <td>SPH</td><td>CYL</td><td>AXIS</td><td>PD</td><td>VA</td><td>SPH</td><td>CYL</td><td>AXIS</td><td>PD</td><td>VA</td>
              </tr>
              <tr>
                <td>${rx.sphRight || "-"}</td><td>${rx.cylRight || "-"}</td><td>${rx.axisRight || "-"}</td><td>${rx.pdRight || "-"}</td><td>${rx.vaRight || "-"}</td>
                <td>${rx.sphLeft || "-"}</td><td>${rx.cylLeft || "-"}</td><td>${rx.axisLeft || "-"}</td><td>${rx.pdLeft || "-"}</td><td>${rx.vaLeft || "-"}</td>
              </tr>
              </table>
          </div>`;
      }
      return `<tr><td style="padding:8px; border:1px solid #000; text-align:center;">${idx + 1}</td><td style="padding:8px; border:1px solid #000;">${item.productName.toUpperCase()} - ${item.productCode}${rxHtml}</td></tr>`;
    }).join("");

    const docContent = `
      <html>
        <head><style>body { font-family: sans-serif; padding: 20px; } table { width:100%; border-collapse:collapse; }</style></head>
        <body>
          <h2 style="text-align:center; text-decoration:underline;">PRODUCTION ORDER FORM</h2>
          <p><strong>Invoice Reference:</strong> ${order.invoiceNo} | <strong>Booking Date:</strong> ${orderDateStr} | <strong>Target Delivery:</strong> ${deliveryDateStr}</p>
          <p><strong>Customer Target Profile:</strong> ${order.customer?.name?.toUpperCase() || "WALK-IN CLIENT"}</p>
          <table style="margin-top:20px;">
            <tr style="background:#e5e7eb;">
              <th style="border:1px solid #000; width:10%; padding:8px;">SL</th><th style="border:1px solid #000; padding:8px;">SPECIFICATIONS RECORD</th>
            </tr>
            ${itemsHtml}
          </table>
          <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); }</script>
        </body>
      </html>`;
    printWindow.document.write(docContent); printWindow.document.close();
  };

  const handlePrintPrescription = (order) => {
    if (!order.prescription) return alert("No operational eye diagnostic data found within this transaction token structure.");
    const printWindow = window.open("", "_blank");
    const record = order.prescription;
    const rxHtml = `
      <html>
        <head><style>body{ font-family:sans-serif; padding:30px; } table { width:100%; border-collapse:collapse; margin-top:20px; } td, th { border:1px solid #000; padding:10px; text-align:center; }</style></head>
        <body>
          <h3>CLINICAL PRESCRIPTION SHEET</h3>
          <p><strong>Patient Name:</strong> ${record.patient?.name || "Walk-In"} | <strong>Age/Gender:</strong> ${record.patient?.age || "-"}/${record.patient?.gender || "-"}</p>
          <p><strong>Optometrist:</strong> ${record.doctor?.name || "Shruti Eye Care Specialist"}</p>
          <table>
            <tr style="background:#f3f4f6;"><th>EYE MATRIX</th><th>SPH</th><th>CYL</th><th>AXIS</th><th>VA</th></tr>
            <tr><td>RIGHT EYE (OD)</td><td>${record.sphRight || "-"}</td><td>${record.cylRight || "-"}</td><td>${record.axisRight || "-"}</td><td>${record.vaRight || "-"}</td></tr>
            <tr><td>LEFT EYE (OS)</td><td>${record.sphLeft || "-"}</td><td>${record.cylLeft || "-"}</td><td>${record.axisLeft || "-"}</td><td>${record.vaLeft || "-"}</td></tr>
          </table>
          <p style="margin-top:30px;"><strong>Clinical Directives:</strong> ${record.prescriptionNotes || "Use regular prescription frames as directed."}</p>
          <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); }</script>
        </body>
      </html>`;
    printWindow.document.write(rxHtml); printWindow.document.close();
  };

  const handlePrintReceipt = (order, type = "final") => {
    const printWindow = window.open("", "_blank");
    const isAdvance = type === "advance";
    const netAmount = order.financials?.netPayable || 0;
    const paid = order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0;
    const bal = order.financials?.balanceDue || 0;

    const receiptHtml = `
      <html>
        <head><style>body{ font-family:sans-serif; padding:25px; line-height:1.5; } .flex { display:flex; justify-content:space-between; }</style></head>
        <body>
          <h2 style="text-align:center; border-bottom:2px solid #000; padding-bottom:10px;">${isAdvance ? "DEPOSIT ADVANCE RECEIPT" : "FINAL TRANSACTION INVOICE"}</h2>
          <div class="flex">
            <div><strong>Invoice ID:</strong> ${order.invoiceNo}<br/><strong>Customer Target:</strong> ${order.customer?.name || "Walk-In"}</div>
            <div><strong>Timestamp:</strong> ${new Date(order.timestamp).toLocaleDateString("en-GB")}</div>
          </div>
          <hr style="margin:20px 0;"/>
          <h4>ACCOUNT BALANCES PROFILE</h4>
          <div class="flex"><span>Total Bill Statement:</span><strong>₹${Number(netAmount).toFixed(2)}</strong></div>
          <div class="flex"><span>Total Assets Realized:</span><strong style="color:green;">₹${Number(paid).toFixed(2)}</strong></div>
          <div class="flex"><span>Outstanding Liability:</span><strong style="color:red;">₹${Number(bal).toFixed(2)}</strong></div>
          <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); }</script>
        </body>
      </html>`;
    printWindow.document.write(receiptHtml); printWindow.document.close();
  };

  return (
    <div className="flex min-h-screen bg-slate-50 text-slate-800 font-sans antialiased selection:bg-blue-200 text-base">
      <Sidebar />

      {/* BALANCE REALIZATION TERMINAL WINDOW MODAL */}
      <AnimatePresence>
        {completingOrder && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-6 shadow-2xl">
              <h3 className="text-lg font-black text-slate-800 border-b border-slate-100 pb-3 mb-4">Settle Deferred Balance</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-sm font-bold text-slate-500">Unsettled Base Balance</span>
                  <span className="text-lg font-black text-slate-800 font-mono">₹{completingOrder.financials.balanceDue.toLocaleString()}</span>
                </div>
                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Apply Account Adjustments (+/-)</label>
                  <input type="number" placeholder="0" value={completionRoundOff} onChange={(e) => setCompletionRoundOff(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl outline-none font-mono font-bold text-slate-800 focus:bg-white focus:border-blue-500" />
                </div>
                <div className="bg-emerald-50 p-4 rounded-xl border border-emerald-100 text-center">
                  <span className="text-xs font-bold text-emerald-600 uppercase tracking-wider block mb-1">Total Realized Collection</span>
                  <span className="text-3xl font-black text-emerald-700 font-mono">
                    ₹{Math.max(0, completingOrder.financials.balanceDue - (Number(completionRoundOff) || 0)).toLocaleString()}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Channel</label>
                    <select value={completionPaymentMode} onChange={e => {setCompletionPaymentMode(e.target.value); setCompletionPaymentDetails("");}} className="w-full p-3 border border-slate-300 rounded-xl outline-none font-bold text-slate-800 focus:border-blue-500">
                      <option>CASH</option><option>UPI / GPay</option><option>Credit Card</option><option>Bank Transfer</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Txn Tokens</label>
                    <input type="text" placeholder={completionPaymentMode === "CASH" ? "N/A" : "Reference ID"} disabled={completionPaymentMode === "CASH"} value={completionPaymentDetails} onChange={(e) => setCompletionPaymentDetails(e.target.value)} className="w-full p-3 border border-slate-300 rounded-xl outline-none font-mono text-xs font-bold text-slate-800 focus:border-blue-500 disabled:bg-slate-100 disabled:text-slate-400" />
                  </div>
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button onClick={() => setCompletingOrder(null)} className="w-1/2 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition">Cancel</button>
                <button onClick={handleFinalizePendingOrder} className="w-1/2 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-black uppercase rounded-xl shadow-lg transition">Commit Settle</button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* WORKSPACE PRODUCT QUICK-ADD INJECTOR POPUP */}
      <AnimatePresence>
        {showProductTypePopup && (
          <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <motion.div initial={{scale:0.95}} animate={{scale:1}} exit={{scale:0.95}} className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[85vh]">
              <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                <h3 className="text-lg font-black uppercase text-slate-800 flex items-center gap-2">
                  <Plus size={20} className="text-blue-600" /> Quick Configure: {selectedProductType}
                </h3>
                <button onClick={() => { setShowProductTypePopup(false); setQuickAddForm(null); }} className="p-2 bg-slate-200 text-slate-600 rounded-xl hover:bg-rose-100 hover:text-rose-600 transition"><X size={18}/></button>
              </div>

              {quickAddForm ? (
                <div className="p-6 space-y-4 overflow-y-auto">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Product Reference Code</label>
                      <input type="text" value={quickAddForm.product.productCode} readOnly className="w-full p-2.5 bg-slate-100 border border-slate-200 rounded-xl text-xs font-mono font-bold text-slate-600" />
                    </div>
                    <div>
                      <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Product Label Designation</label>
                      <input type="text" value={quickAddForm.product.productName} readOnly className="w-full p-2.5 bg-slate-100 border border-slate-200 rounded-xl text-xs font-bold text-slate-600" />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Unit Value Pricing Matrix</label>
                      <input type="number" value={quickAddForm.retailPrice} onChange={e => setQuickAddForm({...quickAddForm, retailPrice: e.target.value})} className="w-full p-2.5 bg-white border border-blue-300 rounded-xl text-xs font-mono font-bold text-blue-700 outline-none focus:ring-2 focus:ring-blue-100" />
                    </div>
                    <div>
                      <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Operational GST Liability (%)</label>
                      <input type="number" value={quickAddForm.gstPercent} onChange={e => setQuickAddForm({...quickAddForm, gstPercent: e.target.value})} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl text-xs font-mono font-bold outline-none" />
                    </div>
                  </div>
                  <div className="flex gap-3 pt-4">
                    <button onClick={() => setQuickAddForm(null)} className="flex-1 py-3 bg-slate-100 text-slate-700 font-bold rounded-xl transition">Back</button>
                    <button onClick={() => {
                        addToCartAction(quickAddForm.product, { retailPrice: Number(quickAddForm.retailPrice) });
                        setShowProductTypePopup(false); setQuickAddForm(null);
                    }} className="flex-1 py-3 bg-blue-600 text-white font-black uppercase rounded-xl shadow-lg hover:bg-blue-500 transition">Confirm Workspace Capture</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="p-4 border-b border-slate-100">
                    <div className="relative flex items-center">
                      <Search size={18} className="absolute left-4 text-slate-400"/>
                      <input type="text" placeholder={`Query index filters for ${selectedProductType}...`} value={productTypeSearchQuery} onChange={e => setProductTypeSearchQuery(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-slate-100 border-none rounded-xl outline-none font-bold text-slate-700 focus:ring-2 focus:ring-blue-500 transition-shadow"/>
                    </div>
                  </div>
                  <div className="overflow-y-auto p-4 flex-1">
                    {products.filter(p => (p.productType || "").toLowerCase().includes(selectedProductType.toLowerCase())).map(prod => (
                      <div key={prod.id} className="flex justify-between items-center p-3 border border-slate-100 rounded-xl mb-2 hover:bg-blue-50 cursor-pointer" onClick={() => setQuickAddForm({ product: prod, retailPrice: prod.retailPrice || prod.mrp || 0, discountType:"amount", discountValue:0, gstPercent:0 })}>
                        <div>
                          <div className="font-bold text-slate-800">{prod.productName}</div>
                          <div className="text-xs text-slate-400 font-mono">Ref Token: {prod.productCode} | Registry Quantity: {prod.quantity}</div>
                        </div>
                        <div className="flex items-center gap-4">
                          <div className="font-black text-blue-600">₹{Number(prod.retailPrice || 0).toLocaleString()}</div>
                          <button className="px-4 py-2 bg-slate-900 text-white text-xs font-bold rounded-lg uppercase transition shadow-sm">Map Item</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CENTRAL CLINICAL MEDICAL PARAMETERS MODAL MATRIX */}
      <AnimatePresence>
        {showPrescriptionModal && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-md flex items-center justify-center p-4">
            <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} exit={{ scale: 0.95 }} className="bg-white rounded-3xl p-8 shadow-2xl w-full max-w-5xl relative max-h-[95vh] overflow-y-auto">
              <button onClick={() => setShowPrescriptionModal(false)} className="absolute top-6 right-6 text-slate-400 hover:text-rose-500 bg-slate-100 p-2 rounded-xl"><X size={20} /></button>
              <h2 className="text-xl font-black uppercase text-slate-800 flex items-center gap-3 border-b pb-4 mb-6"><Stethoscope className="text-purple-600"/> Clinical Ophthalmic Refraction Matrix</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 bg-slate-50 p-4 rounded-xl border">
                <div className="space-y-3">
                  <h4 className="text-xs font-black text-purple-700 uppercase">Patient Metrics Mapping</h4>
                  <div className="grid grid-cols-2 gap-2">
                    <input type="text" placeholder="Patient Name" value={patientName} onChange={e => setPatientName(e.target.value)} className="p-2 bg-white text-xs border rounded-lg outline-none" />
                    <input type="text" placeholder="Mobile Phone" value={patientMobile} onChange={e => setPatientMobile(e.target.value)} className="p-2 bg-white text-xs border rounded-lg outline-none" />
                  </div>
                </div>
                <div className="space-y-3">
                  <h4 className="text-xs font-black text-emerald-700 uppercase">Attending Practitioner Signature</h4>
                  <input type="text" placeholder="Specialist Physician Name" value={doctorName} onChange={e => setDoctorName(e.target.value)} className="w-full p-2 bg-white text-xs border rounded-lg outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-4 border rounded-xl bg-white space-y-4">
                  <span className="text-xs font-black text-purple-600 block border-b pb-1">Oculus Dexter (Right Eye - OD) Matrix</span>
                  <div className="grid grid-cols-3 gap-2">
                    <input type="text" placeholder="SPH" value={sphRight} onChange={e => setSphRight(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                    <input type="text" placeholder="CYL" value={cylRight} onChange={e => setCylRight(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                    <input type="text" placeholder="AXIS" value={axisRight} onChange={e => setAxisRight(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                  </div>
                </div>
                <div className="p-4 border rounded-xl bg-white space-y-4">
                  <span className="text-xs font-black text-purple-600 block border-b pb-1">Oculus Sinister (Left Eye - OS) Matrix</span>
                  <div className="grid grid-cols-3 gap-2">
                    <input type="text" placeholder="SPH" value={sphLeft} onChange={e => setSphLeft(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                    <input type="text" placeholder="CYL" value={cylLeft} onChange={e => setCylLeft(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                    <input type="text" placeholder="AXIS" value={axisLeft} onChange={e => setAxisLeft(e.target.value)} className="p-2 border text-center rounded-lg text-xs" />
                  </div>
                </div>
              </div>

              <div className="mt-6 flex justify-end">
                <button onClick={() => setShowPrescriptionModal(false)} className="px-6 py-3 bg-purple-600 text-white rounded-xl text-xs font-black uppercase flex items-center gap-2 tracking-wider shadow-lg"><CheckCircle2 size={16}/> Cache Parameters to Form Token</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="flex-1 p-6 lg:p-10 space-y-8 overflow-x-hidden">
        {/* CORE WORKSPACE COMMAND COMPONENT HEADER */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between p-6 bg-white border border-slate-200 rounded-3xl gap-6 shadow-sm">
          <div>
            <h1 className="text-2xl font-black text-slate-800 uppercase tracking-wider">Super Admin Sales Management Console</h1>
            <div className="flex items-center gap-2 mt-2 text-sm text-slate-500 font-medium">
              <Building2 size={14} className="text-blue-500" />
              <span>Network Context Workspace: </span>
              <span className="bg-blue-50 text-blue-700 font-black px-3 py-1 rounded-xl text-xs uppercase tracking-widest border">
                {storeName}
              </span>
            </div>
          </div>

          <div className="flex bg-slate-100 p-1.5 rounded-2xl border text-xs font-bold">
            <button onClick={() => setActiveTab("storeReports")} className={`px-4 py-2.5 rounded-xl transition-all ${activeTab === "storeReports" ? "bg-white text-purple-600 shadow-sm font-black" : "text-slate-500 hover:text-slate-800"}`}>Macro Analysis Desk</button>
            <button onClick={() => setActiveTab("salesHistory")} className={`px-4 py-2.5 rounded-xl transition-all ${activeTab === "salesHistory" ? "bg-white text-blue-600 shadow-sm font-black" : "text-slate-500 hover:text-slate-800"}`}>Master Transact Ledger</button>
            <button onClick={() => setActiveTab("orderWorkspace")} className={`px-4 py-2.5 rounded-xl transition-all ${activeTab === "orderWorkspace" ? "bg-white text-emerald-600 shadow-sm font-black" : "text-slate-500 hover:text-slate-800"}`}>Order Modification Workspace</button>
          </div>
        </div>

        {/* ALERTS CONTROL BOX CONTAINER */}
        <AnimatePresence>
          {systemError && (
            <motion.div initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="p-4 bg-rose-50 border border-rose-200 text-rose-700 rounded-2xl flex items-center justify-between shadow-sm text-xs font-bold">
              <div className="flex items-center gap-2"><AlertCircle size={16}/><span>{systemError}</span></div>
              <button onClick={() => setSystemError(null)} className="text-rose-400 hover:text-rose-600"><X size={16}/></button>
            </motion.div>
          )}
        </AnimatePresence>

        {/* HIGH-VISIBILITY GLOBAL AND STOREWISE BREAKDOWN CONTROLLER */}
        <div className="bg-white border border-slate-200 rounded-3xl p-5 shadow-sm space-y-3">
          <span className="text-[10px] font-black uppercase text-slate-400 tracking-widest block px-1">Network Infrastructure Routing Channels</span>
          <div className="flex gap-3 overflow-x-auto pb-1">
            <button onClick={() => { setActiveBranchId("all_combined"); resetForm(); }} className={`min-w-[200px] p-4 rounded-2xl border transition-all text-left flex items-center gap-3 shrink-0 ${activeBranchId === "all_combined" ? "bg-slate-900 border-slate-900 text-white shadow-xl shadow-slate-200" : "bg-slate-50 text-slate-700 hover:border-slate-300"}`}>
              <div className={`p-2 rounded-xl ${activeBranchId === "all_combined" ? "bg-blue-600 text-white" : "bg-slate-200 text-slate-600"}`}><Globe size={18}/></div>
              <div><h4 className="text-xs font-black uppercase tracking-wider">Global Matrix View</h4><p className="text-[9px] font-medium opacity-60 mt-0.5">Aggregated Store Channels</p></div>
            </button>
            {storesList.map(store => (
              <button key={store.id} onClick={() => { setActiveBranchId(store.id); resetForm(); }} className={`min-w-[200px] p-4 rounded-2xl border transition-all text-left flex items-center gap-3 shrink-0 ${activeBranchId === store.id ? "bg-blue-600 border-blue-600 text-white shadow-xl shadow-blue-100" : "bg-slate-50 text-slate-700 hover:border-slate-300"}`}>
                <div className={`p-2 rounded-xl ${activeBranchId === store.id ? "bg-white text-blue-600" : "bg-slate-200 text-slate-600"}`}><Building2 size={18}/></div>
                <div className="truncate"><h4 className="text-xs font-black uppercase tracking-wider truncate">{store.storeName || store.id}</h4><p className={`text-[9px] font-medium truncate mt-0.5 ${activeBranchId === store.id ? "text-blue-100" : "text-slate-400"}`}>{store.address || "Operational Node"}</p></div>
              </button>
            ))}
          </div>
        </div>

        {/* SYSTEM INTEGRATION FILTER CONTROLS TOOLBAR */}
        <div className="bg-white border border-slate-200 rounded-3xl p-5 shadow-sm flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
            <div className="flex items-center gap-2 bg-slate-50 border px-3 py-2 rounded-xl text-xs font-bold text-slate-600"><Calendar size={14}/><span>Start:</span><input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="bg-transparent outline-none cursor-pointer font-mono"/></div>
            <div className="flex items-center gap-2 bg-slate-50 border px-3 py-2 rounded-xl text-xs font-bold text-slate-600"><Calendar size={14}/><span>End:</span><input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="bg-transparent outline-none cursor-pointer font-mono"/></div>
            <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="px-3 py-2 bg-slate-50 border rounded-xl text-xs font-bold outline-none cursor-pointer">
              <option value="">All Verification Realizations</option>
              <option value="Pending">Pending Allocations</option>
              <option value="Completed">Direct Settled Invoices</option>
            </select>
            <div className="relative"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/><input type="text" placeholder="Search tokens, tags, customer records..." value={filterSearch} onChange={e => setFilterSearch(e.target.value)} className="pl-9 pr-4 py-2 bg-slate-50 border rounded-xl text-xs font-bold outline-none w-64 focus:border-blue-500 transition-colors"/></div>
          </div>

          <div className="flex gap-2 w-full md:w-auto justify-end">
            {activeTab === "storeReports" ? (
              <>
                <button onClick={handleExportReportExcel} className="flex gap-2 items-center bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-600 hover:text-white px-4 py-2 rounded-xl font-black text-xs uppercase tracking-wider transition-all"><Download size={13}/> Export Micro Excel</button>
                <button onClick={handlePrintReportPDF} className="flex gap-2 items-center bg-purple-50 text-purple-700 border border-purple-200 hover:bg-purple-600 hover:text-white px-4 py-2 rounded-xl font-black text-xs uppercase tracking-wider transition-all"><FileText size={13}/> Global Report PDF</button>
              </>
            ) : (
              <>
                <button onClick={handlePrintLedger} className="flex gap-2 items-center bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-600 hover:text-white px-4 py-2 rounded-xl font-black text-xs uppercase tracking-wider transition-all"><Printer size={13}/> Print Active Ledger</button>
              </>
            )}
          </div>
        </div>

        {/* WORKSPACE 1: HIGH PERFORMANCE CORPORATE REPORTING DESK */}
        {activeTab === "storeReports" && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="bg-white border border-slate-200 p-6 rounded-3xl flex flex-col items-center justify-center space-y-4 shadow-sm">
                <h4 className="text-xs font-black uppercase text-slate-400 tracking-widest">Liquid Cash Asset Distribution</h4>
                <div className="relative w-40 h-48 rounded-full border-4 border-white flex items-center justify-center shadow-sm" style={{ background: reportSummaryData.gradient }}>
                  <div className="w-28 h-28 bg-white rounded-full flex flex-col items-center justify-center shadow-inner">
                    <span className="text-[9px] font-bold text-slate-400 uppercase">Net Assets</span>
                    <span className="text-base font-black text-slate-800 font-mono">₹{(reportSummaryData.totalCollected).toLocaleString()}</span>
                  </div>
                </div>
                <div className="flex justify-center gap-3 text-[11px] font-bold text-slate-600">
                  <div className="flex items-center gap-1"><div className="w-2 h-2 rounded-full bg-blue-500"/>Cash</div>
                  <div className="flex items-center gap-1"><div className="w-2 h-2 rounded-full bg-emerald-500"/>UPI</div>
                  <div className="flex items-center gap-1"><div className="w-2 h-2 rounded-full bg-purple-500"/>Cards</div>
                </div>
              </div>

              <div className="lg:col-span-2 bg-white border border-slate-200 rounded-3xl p-6 shadow-sm grid grid-cols-2 gap-6 items-center">
                <div className="space-y-1 p-4 bg-slate-50 rounded-2xl border border-slate-100"><span className="text-[10px] font-black uppercase text-slate-400 block">Total Statement Gross Value</span><h2 className="text-2xl font-black font-mono text-slate-800">₹{reportSummaryData.totalNet.toLocaleString()}</h2></div>
                <div className="space-y-1 p-4 bg-slate-50 rounded-2xl border border-slate-100"><span className="text-[10px] font-black uppercase text-slate-400 block">Total Commitment Deposits</span><h2 className="text-2xl font-black font-mono text-amber-600">₹{reportSummaryData.totalAdvance.toLocaleString()}</h2></div>
                <div className="space-y-1 p-4 bg-slate-50 rounded-2xl border border-slate-100"><span className="text-[10px] font-black uppercase text-slate-400 block">Differential Valuation Metrics</span><h2 className="text-2xl font-black font-mono text-slate-600">₹{reportSummaryData.totalRoundoff.toLocaleString()}</h2></div>
                <div className="space-y-1 p-4 bg-emerald-50/60 rounded-2xl border border-emerald-100"><span className="text-[10px] font-black uppercase text-emerald-700 block">Net Liquidity Yield Realized</span><h2 className="text-2xl font-black font-mono text-emerald-600">₹{reportSummaryData.totalCollected.toLocaleString()}</h2></div>
              </div>
            </div>

            <div className="bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
              <div className="p-4 bg-slate-50 border-b font-black text-xs uppercase tracking-wider text-slate-600">Macro Cross-Store Transaction View</div>
              <div className="overflow-x-auto max-h-[500px]">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="text-[10px] font-black uppercase text-slate-400 bg-slate-50/40 border-b">
                      <th className="p-3 pl-6">Store Context</th><th className="p-3">Invoice & Timestamp</th><th className="p-3">Customer Target</th><th className="p-3">Line-Item Specs Context</th><th className="p-3 text-right">Commitments</th><th className="p-3 text-right">Yield Gross</th>
                    </tr>
                  </thead>
                  <tbody className="text-xs font-bold divide-y divide-slate-100">
                    {completedSalesLedger.map(order => (
                      <tr key={order.id} className="hover:bg-slate-50/50">
                        <td className="p-3 pl-6 text-purple-700 font-black uppercase tracking-wider text-[10px]">{order.branchContextName || "Main Channel"}</td>
                        <td className="p-3"><div className="font-mono text-slate-800">{order.invoiceNo}</div><div className="text-[10px] font-normal text-slate-400 mt-0.5">{order.timestamp?.split("T")[0]}</div></td>
                        <td className="p-3"><div>{order.customer?.name || "Walk-In"}</div><div className="text-[10px] font-normal text-slate-400 mt-0.5">{order.customer?.phone || "-"}</div></td>
                        <td className="p-3 max-w-xs"><div className="flex flex-col gap-0.5">{(order.items || []).map((i, idx) => <span key={idx} className="bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded text-[10px] truncate">{i.productName} (x{i.quantity})</span>)}</div></td>
                        <td className="p-3 text-right font-mono text-amber-600">₹{Number(order.checkout?.advancePaid || 0).toFixed(2)}</td>
                        <td className="p-3 pr-6 text-right font-mono text-emerald-600 text-sm">₹{Number(order.financials?.netPayable || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* WORKSPACE 2: CENTRAL TRANSACTION RE-ROUTING MASTER LEDGER */}
        {activeTab === "salesHistory" && (
          <div className="bg-white border border-slate-200 rounded-3xl shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="text-[10px] font-black uppercase text-slate-400 tracking-wider bg-slate-50 border-b">
                    <th className="p-4 pl-6">Store Node</th><th className="p-4">Invoice #</th><th className="p-4">Customer Profile</th><th className="p-4">Agent / Date</th><th className="p-4 text-right">Gross Value</th><th className="p-4 text-right">Realized</th><th className="p-4 text-right">Outstanding</th><th className="p-4 text-center">Status</th><th className="p-4 pr-6 text-right">Action Matrix Control Console</th>
                  </tr>
                </thead>
                <tbody className="text-xs font-bold divide-y divide-slate-100">
                  {completedSalesLedger.length === 0 ? (
                    <tr><td colSpan="9" className="p-12 text-center text-slate-400">No transactions matched matching active channel registers.</td></tr>
                  ) : (
                    completedSalesLedger.map(order => {
                      const net = order.financials?.netPayable || 0;
                      const paid = order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0;
                      const bal = order.financials?.balanceDue || 0;
                      const isPending = bal > 0;

                      return (
                        <tr key={order.id} className="hover:bg-slate-50/60 transition-colors">
                          <td className="p-4 pl-6 text-purple-700 text-[10px] uppercase tracking-wider font-black">{order.branchContextName || "Standard Branch"}</td>
                          <td className="p-4 font-mono font-black text-blue-600">{order.invoiceNo}</td>
                          <td className="p-4"><div>{order.customer?.name}</div><div className="text-[10px] text-slate-400 font-mono font-normal">{order.customer?.phone}</div></td>
                          <td className="p-4"><div>{order.salesperson || "System"}</div><div className="text-[10px] text-slate-400 font-mono font-normal">{new Date(order.timestamp).toLocaleDateString("en-GB")}</div></td>
                          <td className="p-4 text-right font-mono text-slate-800">₹{net.toLocaleString()}</td>
                          <td className="p-4 text-right font-mono text-emerald-600">₹{paid.toLocaleString()}</td>
                          <td className="p-4 text-right font-mono text-rose-600">₹{bal.toLocaleString()}</td>
                          <td className="p-4 text-center">
                            <span className={`px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-wider ${isPending ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>{isPending ? "Pending" : "Settled"}</span>
                          </td>
                          <td className="p-4 pr-6">
                            <div className="flex gap-1.5 justify-end items-center">
                              {isPending && (
                                <button onClick={() => triggerCompletionFlow(order)} title="Settle Remaining Outstanding Balance" className="p-2 bg-emerald-50 hover:bg-emerald-600 hover:text-white text-emerald-700 rounded-xl transition"><CheckCircle2 size={14}/></button>
                              )}
                              <button onClick={() => loadOrderForEditing(order)} title="Cross-Load Record to Form Modifier" className="p-2 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 rounded-xl transition"><Edit3 size={14}/></button>
                           </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* WORKSPACE 3: ACTIVE MODIFICATION AND TRANSACT CONTROL FORM */}
        {activeTab === "orderWorkspace" && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {activeBranchId === "all_combined" ? (
              <div className="col-span-12 p-12 bg-white text-center rounded-3xl border border-slate-200 text-slate-400 space-y-3 shadow-sm">
                <Building2 size={44} className="mx-auto text-slate-300 stroke-[1.5]"/>
                <p className="text-sm font-bold">Billing Form Operations Blocked. Select a distinct branch location card above to operate billing workflows or edit logs.</p>
              </div>
            ) : (
              <>
                {/* LEFT CONSOLE BLOCK: INVENTORY SEARCH AND CART BUILDER */}
                <div className="col-span-1 lg:col-span-7 space-y-6">
                  {editOrderId && (
                    <div className="bg-blue-50 border border-blue-200 p-4 rounded-2xl flex justify-between items-center shadow-sm">
                      <div className="flex items-center gap-3 text-blue-700">
                        <Edit3 size={20}/>
                        <div>
                          <h3 className="font-black uppercase tracking-wider text-xs">Full Order Modification Workspace Form Active</h3>
                          <p className="text-[10px] font-mono mt-0.5">Overwriting Token Ref: {orderReference}</p>
                        </div>
                      </div>
                      <button onClick={resetForm} className="px-4 py-2 bg-white text-blue-600 border border-blue-200 text-xs font-bold uppercase rounded-xl hover:bg-blue-600 hover:text-white transition">Cancel Workspace Session</button>
                    </div>
                  )}

                  <div className="relative">
                    <div className="flex items-center bg-white border rounded-2xl p-2 shadow-sm focus-within:border-blue-500 transition-colors">
                      <Search size={20} className="text-slate-400 mx-3 shrink-0" />
                      <input type="text" placeholder="Scan system barcode or type catalog SKU labels..." value={skuSearchQuery} onChange={e => setSkuSearchQuery(e.target.value)} className="w-full py-2 outline-none font-bold text-slate-800 placeholder:font-normal text-sm" />
                    </div>

                    <div className="flex flex-wrap gap-2 mt-3">
                      {["Frame", "Lens", "Sunglasses", "Contact Lens", "Other"].map((cat) => (
                        <button key={cat} onClick={() => { setSelectedProductType(cat); setProductTypeSearchQuery(""); setShowProductTypePopup(true); }} className="px-3 py-1.5 bg-white border text-slate-600 text-[10px] font-black uppercase tracking-wider rounded-xl hover:bg-blue-50 hover:text-blue-600 transition-all shadow-sm">+ Add {cat}</button>
                      ))}
                    </div>

                    {scannedMatches.length > 0 && (
                      <div className="absolute top-[52px] left-0 right-0 bg-white border rounded-2xl shadow-2xl z-50 max-h-60 overflow-y-auto divide-y">
                        {scannedMatches.map(prod => (
                          <div key={prod.id} onClick={() => addToCartAction(prod)} className="p-3 hover:bg-blue-50 cursor-pointer flex justify-between items-center font-bold">
                            <div><div className="text-slate-800">{prod.productName}</div><div className="text-[10px] text-slate-400 font-mono font-normal">SKU: {prod.productCode}</div></div>
                            <div className="text-right"><div className="text-blue-600">₹{Number(prod.retailPrice).toLocaleString()}</div><div className="text-[10px] text-slate-500">Registry Stock: {prod.quantity}</div></div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="bg-white p-4 rounded-2xl border shadow-sm flex flex-wrap gap-2.5 items-center justify-between">
                    <span className="text-xs font-black uppercase text-slate-400 tracking-wider flex items-center gap-1"><Plus size={14}/> Custom Entry</span>
                    <div className="flex flex-wrap flex-1 gap-2">
                      <input type="text" placeholder="SKU ID" value={customItem.productCode} onChange={e => setCustomItem({...customItem, productCode: e.target.value})} className="p-2 text-xs bg-slate-50 border rounded-xl outline-none font-mono uppercase w-24 font-bold" />
                      <input type="text" placeholder="Line-Item Description" value={customItem.productName} onChange={e => setCustomItem({...customItem, productName: e.target.value})} className="p-2 text-xs bg-slate-50 border rounded-xl outline-none flex-1 font-bold" />
                      <input type="number" placeholder="Price ₹" value={customItem.customPrice} onChange={e => setCustomItem({...customItem, customPrice: e.target.value})} className="p-2 text-xs bg-slate-50 border rounded-xl outline-none w-20 font-mono font-bold text-blue-600" />
                    </div>
                    <button onClick={handleInjectCustomProduct} className="px-4 py-2 bg-slate-900 hover:bg-blue-600 text-white rounded-xl text-xs font-bold uppercase tracking-wider shadow-sm">Inject</button>
                  </div>

                  <div className="bg-white border rounded-3xl shadow-sm overflow-hidden">
                    <div className="p-4 bg-slate-50 border-b flex justify-between items-center font-black text-xs uppercase tracking-wider text-slate-600">
                      <span>Workspace Cart Builder Ledger ({billingCart.length})</span>
                    </div>

                    {billingCart.length === 0 ? (
                      <div className="p-12 text-center text-slate-400 space-y-2">
                        <ShoppingCart size={32} className="mx-auto text-slate-300 stroke-[1.5]" />
                        <p className="text-xs font-medium">Workspace cart currently completely empty.</p>
                      </div>
                    ) : (
                      <div className="divide-y overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                          <thead>
                            <tr className="text-[10px] font-black uppercase text-slate-400 bg-slate-50/50 border-b">
                              <th className="p-3 pl-4">Product Context</th><th className="p-3 text-right">Rate</th><th className="p-3 text-center">Qty</th><th className="p-3 text-right">Disc (₹)</th><th className="p-3 text-right">Net</th><th className="p-3 text-center"></th>
                            </tr>
                          </thead>
                          <tbody className="text-xs font-bold divide-y divide-slate-100">
                            {billingCart.map(item => {
                              const unitPrice = Number(item.retailPrice) || 0;
                              const qty = Number(item.cartQuantity) || 1;
                              const disc = Number(item.customDiscount) || 0;
                              return (
                                <tr key={item.id} className="hover:bg-slate-50/50">
                                  <td className="p-3 pl-4"><div>{item.productName}</div><div className="text-[9px] text-slate-400 font-mono font-normal">{item.productCode}</div></td>
                                  <td className="p-3 text-right font-mono text-slate-500">₹{unitPrice.toLocaleString()}</td>
                                  <td className="p-3 text-center"><input type="number" min="1" value={item.cartQuantity} onChange={e => updateCartQty(item.id, e.target.value)} className="w-12 p-1 text-center bg-slate-100 border rounded-lg font-mono font-bold outline-none" /></td>
                                  <td className="p-3 text-right"><input type="number" min="0" value={item.customDiscount || ""} onChange={e => updateCartDiscount(item.id, e.target.value)} className="w-14 p-1 text-right bg-slate-100 border rounded-lg font-mono font-bold text-purple-700 outline-none" /></td>
                                  <td className="p-3 text-right font-mono text-blue-600">₹{((unitPrice * qty) - disc).toLocaleString()}</td>
                                  <td className="p-3 text-center"><button onClick={() => updateCartQty(item.id, 0)} className="text-slate-300 hover:text-rose-500"><X size={14}/></button></td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="p-4 bg-purple-50/50 border-t flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                      <div className="flex items-center gap-2">
                        <div className="p-1.5 bg-purple-600 text-white rounded-lg shadow-sm"><Stethoscope size={16}/></div>
                        <div>
                          <div className="text-xs font-black uppercase text-purple-950">Clinical Data Association Status</div>
                          <div className="text-[10px] text-purple-700 font-medium mt-0.5">{patientName || doctorName ? ` Tethers Formed: ${patientName || "Unnamed"} (Dr. ${doctorName || "Self-Check"})` : "No ophthalmic values currently tethered to checkout token."}</div>
                        </div>
                      </div>
                      <button onClick={() => setShowPrescriptionModal(true)} className="px-3 py-1.5 bg-purple-600 hover:bg-purple-700 text-white text-[10px] font-black uppercase rounded-lg transition shadow-sm shrink-0">Configure Diagnostic Values</button>
                    </div>
                  </div>
                </div>

                {/* RIGHT CONSOLE BLOCK: LOGISTICS, PROFILING & FINANCIAL CHECKOUT */}
                <div className="col-span-1 lg:col-span-5 space-y-6">
                  <div className="bg-white border rounded-3xl p-5 shadow-sm space-y-4">
                    <h3 className="font-black text-slate-800 uppercase tracking-wider text-xs border-b pb-2 flex items-center gap-2"><User size={15} className="text-blue-600"/> Target Client Assignment Profile</h3>
                    <div className="grid grid-cols-2 gap-3">
                      <div><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Primary Mobile *</label><input type="tel" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} onBlur={handlePhoneBlurCustomer} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-mono font-bold outline-none focus:bg-white" /></div>
                      <div><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Alt Contact</label><input type="tel" value={customerPhone2} onChange={e => setCustomerPhone2(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-mono font-bold outline-none focus:bg-white" /></div>
                      <div className="col-span-2"><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Client Full Identity Name *</label><input type="text" value={customerName} onChange={e => setCustomerName(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-bold text-slate-800 outline-none focus:bg-white" /></div>
                      <div className="col-span-2"><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Street Address Parameters</label><input type="text" value={customerAddress} onChange={e => setCustomerAddress(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-bold outline-none focus:bg-white" /></div>
                    </div>
                  </div>

                  <div className="bg-white border rounded-3xl p-5 shadow-sm space-y-4">
                    <h3 className="font-black text-slate-800 uppercase tracking-wider text-xs border-b pb-2 flex items-center gap-2"><FileText size={15} className="text-purple-600"/> Attending Agent & Processing Context</h3>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="col-span-2">
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Attending Field Agent *</label>
                        <select value={salesperson} onChange={e => setSalesperson(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-bold text-slate-800 outline-none cursor-pointer">
                          <option value="">-- Select Attending Staff --</option>
                          {storeEmployees.map(emp => <option key={emp.id} value={emp.name || emp.id}>{emp.name || emp.id}</option>)}
                        </select>
                      </div>
                      <div><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Delivery Context Date</label><input type="date" value={deliveryDate} onChange={e => setDeliveryDate(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-mono font-bold outline-none" /></div>
                      <div><label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Manual Overwrite ID Reference</label><input type="text" placeholder="Auto-generator active" value={orderReference} onChange={e => setOrderReference(e.target.value)} className="w-full p-2 bg-slate-50 border rounded-xl text-xs font-mono font-bold uppercase outline-none" /></div>
                    </div>
                  </div>

                  <div className="bg-slate-900 text-white rounded-3xl p-5 shadow-xl space-y-4">
                    <h3 className="font-black uppercase tracking-wider text-xs border-b border-slate-800 pb-2 flex items-center justify-between text-slate-300">
                      <span className="flex items-center gap-2"><CreditCard size={15} className="text-emerald-400"/> Financial Checkout Terminal Matrix</span>
                    </h3>

                    <div className="space-y-2.5 text-xs font-bold">
                      <div className="flex justify-between text-slate-400 font-medium"><span>Subtotal Gross Accumulations</span><span className="font-mono text-white">₹{financials.subtotal.toLocaleString()}</span></div>
                      
                      <div className="py-2 border-y border-slate-800 flex justify-between items-center gap-2">
                        <span className="text-slate-300 flex items-center gap-1"><Percent size={13} className="text-purple-400" /> Matrix Bill Concessions</span>
                        <div className="flex items-center gap-1.5">
                          <select value={overallDiscountType} onChange={e => setOverallDiscountType(e.target.value)} className="bg-slate-800 text-slate-300 border border-slate-700 rounded-lg p-1 text-[10px] font-bold outline-none cursor-pointer">
                            <option value="amount">Flat (₹)</option><option value="percent">Percent (%)</option>
                          </select>
                          <input type="number" value={overallDiscountValue} onChange={e => setOverallDiscountValue(e.target.value)} className="w-16 p-1 bg-slate-800 border border-slate-700 rounded-lg text-right font-mono text-purple-400 font-bold outline-none focus:border-purple-500" />
                        </div>
                      </div>

                      <div className="py-2 border-b border-slate-800 flex justify-between items-center gap-2">
                        <span className="text-slate-300">Manual adjustments (+/-)</span>
                        <input type="number" placeholder="0.00" value={roundOff} onChange={e => setRoundOff(e.target.value)} className="w-20 p-1 bg-slate-800 border border-slate-700 rounded-lg text-right font-mono text-emerald-400 font-bold outline-none focus:border-emerald-500" />
                      </div>

                      <div className="flex justify-between items-center text-slate-400 font-medium"><span>Tax Computation Base ({taxPercentage}%)</span><span className="font-mono text-white">₹{financials.computedTax.toFixed(2)}</span></div>
                      <div className="flex justify-between items-center pt-2 border-t border-slate-800"><span className="text-slate-300 font-black">Net Certified Liability Value</span><span className="text-base font-mono font-black text-emerald-400">₹{financials.netPayable.toLocaleString()}</span></div>

                      <div className="grid grid-cols-2 gap-3 pt-2">
                        <div>
                          <label className="text-[9px] uppercase text-slate-400 block mb-1">Locked Advance Asset Deposit (₹)</label>
                          <input type="number" value={advancePaid} onChange={e => setAdvancePaid(e.target.value)} className="w-full p-2 bg-slate-800 border border-slate-700 rounded-xl font-mono text-xs text-emerald-400 font-black outline-none focus:border-emerald-500" />
                        </div>
                        <div>
                          <label className="text-[9px] uppercase text-slate-400 block mb-1">Payment Route Channel</label>
                          <select value={paymentMode} onChange={e => {setPaymentMode(e.target.value); setPosPaymentDetails("");}} className="w-full p-2 bg-slate-800 border border-slate-700 rounded-xl text-xs font-bold text-white outline-none cursor-pointer">
                            <option>CASH</option><option>UPI / GPay</option><option>Credit Card</option><option>Bank Transfer</option>
                          </select>
                        </div>
                      </div>

                      <div className={`p-2.5 rounded-xl border text-center flex justify-between items-center mt-2 ${financials.balanceDue > 0 ? "bg-amber-950/30 border-amber-900 text-amber-400" : "bg-emerald-950/30 border-emerald-900 text-emerald-400"}`}>
                        <span className="text-[10px] font-black uppercase tracking-wider">Unsettled Balance Remaining</span>
                        <span className="text-lg font-mono font-black">₹{Math.max(0, financials.balanceDue).toLocaleString()}</span>
                      </div>
                    </div>

                    <div className="pt-3">
                      {editOrderId ? (
                        <button type="button" disabled={isProcessing} onClick={() => commitInvoiceTransaction(false)} className="w-full py-3 bg-blue-600 hover:bg-blue-500 disabled:bg-slate-800 text-white font-black uppercase text-xs tracking-wider rounded-xl transition shadow-lg flex items-center justify-center gap-1"><RefreshCw size={14}/> Save Changes & Overwrite Database Block</button>
                      ) : (
                        <div className="grid grid-cols-2 gap-3">
                          <button type="button" disabled={isProcessing} onClick={() => commitInvoiceTransaction(false)} className="py-3 bg-amber-600 hover:bg-amber-500 disabled:bg-slate-800 text-white font-black uppercase text-[10px] tracking-wider rounded-xl transition flex flex-col items-center justify-center gap-0.5 shadow-md"><span>Commit Partial Order</span><span className="text-[8px] font-normal opacity-75">(Advance Deposit Locked)</span></button>
                          <button type="button" disabled={isProcessing || financials.balanceDue > 0} onClick={() => commitInvoiceTransaction(true)} className="py-3 bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-800 text-white font-black uppercase text-[10px] tracking-wider rounded-xl transition flex flex-col items-center justify-center gap-0.5 shadow-md"><span>Commit Direct Invoice</span><span className="text-[8px] font-normal opacity-75">(100% Cash Settled)</span></button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}